import { queryKeyBuildings } from '@/libs/container/hooks/useBuildingIds.ts';
import { queryKeyClient } from '@/libs/container/hooks/useClientId.ts';
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

export function useCBMLink(id: string) {
  const [searchParams] = useSearchParams();
  return useMemo(() => {
    const params = new URLSearchParams();
    params.set('selectedId', id);
    const clientId = searchParams.get(queryKeyClient) || '';
    const buildingIds = searchParams.get(queryKeyBuildings) || '';
    if (clientId) params.set(queryKeyClient, clientId);
    if (buildingIds) params.set(queryKeyBuildings, buildingIds);
    return `/ui/cbm?${params.toString()}`;
  }, [id, searchParams]);
}
